import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "paginator-more",
  "use": "paginator-more-usage",
  "viewBox": "0 0 15 3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 3\" id=\"paginator-more\">\n    <g fill-rule=\"evenodd\">\n        <circle cx=\"1.5\" cy=\"1.5\" r=\"1.5\" />\n        <circle cx=\"7.5\" cy=\"1.5\" r=\"1.5\" />\n        <circle cx=\"13.5\" cy=\"1.5\" r=\"1.5\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol